<div class="container login">
    <div class="row">
        <div class="col-md-12">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-lg-3 hide">

                        <div class="menu-wrapper">
                            <ul class="static-menu">
                                <li class="menu-title">
                                    KATEGORİLER
                                </li>
                                <li>
                                    <a href="about-us.htm">Hakkımızda</a>
                                </li>
                                <li class="active">
                                    <a href="products.htm">Ürünlerimiz</a>
                                </li>
                                <li>
                                    <a href="mobile-application.htm">Mobil Uygulama</a>
                                </li>
                                <li>
                                    <a href="market-analysis.htm">Pazar Analizi</a>
                                </li>
                                <li>
                                    <a href="market-analysis.htm">Haberler</a>
                                </li>
                            </ul>
                            <ul class="static-menu">
                                <li class="menu-title">
                                    BİLGİLENDİRME
                                </li>
                                <li>
                                    <a href="privacy-policy.htm">Gizlilik Politikası</a>
                                </li>
                                <li>
                                    <a href="terms-of-use.htm"> Kullanım Koşulları</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="static-content">
                            <h2>Ürünlerimiz</h2>
                            <section id="services" class="section-padding">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="services-table clearfix">
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/used_car_pricing']">
                                                        <span class="fwb">2.El Araç</span>
                                                        <span>Fiyat Sorgulama</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="/#new-car">
                                                        <span class="fwb">0 KM Araç</span>
                                                        <span>Fiyat Sorgulama</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="/#new-car">
                                                        <span class="fwb">Araç</span>
                                                        <span>Karşılaştırma</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/instant-cash-offer']">
                                                        <span class="fwb">2.El Araç Tedariği</span>
                                                        <span>Sağlama</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Analiz</span>
                                                        <span>ve Raporlama</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">RV</span>
                                                        <span>(Residual Value)</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">(Güncel ve Geçmiş Yıllar)</span>
                                                        <span>Araç Katalog Bilgisi Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Marka/Model/Model Tipi</span>
                                                        <span>Yapı Ağacı Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Teknik</span>
                                                        <span>Data</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Donanım (Ekipman)</span>
                                                        <span>Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">O KM ve 2.El</span>
                                                        <span>Fiyat Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Fleet</span>
                                                        <span>Re-Valuation</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Gizli Müşteri/Saha</span>
                                                        <span>Çalışmaları</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a  href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Stock Audit</span>
                                                        <span>(Bayi Araç Stok Denetimi)</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="/#digital">
                                                        <span class="fwb">Turkcell BİP’den</span>
                                                        <span>Araç Fiyatı Sorgulama</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Motosiklet</span>
                                                        <span>Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="javascript:;" [routerLink]="['/contact']">
                                                        <span class="fwb">Servis-Bakım</span>
                                                        <span>Datası</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="services-item">
                                                <div>
                                                    <a href="/#digital">
                                                        <span class="fwb">Fiyat Dergisi</span>
                                                        <span>2.El ve 0 KM Araç</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br /><br />
                                <div class="row s-footer">
                                    <div class="col-md-12 tac">
                                        <a href="javascript:;" [routerLink]="['/contact']"
                                            class="btn btn-primary btn-m">Detaylı Bilgi için
                                            İletişime Geçin</a>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>